import { useEffect, useState } from 'react';
import Sidebar from '../../components/sidebar/Sidebar';
import { DriveFolderUploadOutlined } from '@mui/icons-material';
import { onValue, ref, set, update } from 'firebase/database';
import { auth, db, storage } from '../../firebase';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { ref as storeRef } from 'firebase/storage';
import ActivityLog from '../activity/ActivityLog';
// import './UpdateProfile.css';
import { BsFillPersonFill } from "react-icons/bs";

const UpdateProfile = () => {
    const [state, setState] = useState({});
    const navigate = useNavigate();
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState("");

    const email = auth.currentUser.email;
    let encodedEmail = email.replace(/\./g, ',');


    useEffect(() => {
        console.log("updating for profile email: ", encodedEmail)
        const dbRef = ref(db, `Users/${encodedEmail}`);
        onValue(dbRef, (snapshot) => {
            if (snapshot.exists()) {
                setState({ ...snapshot.val() });
            }
        });
    }, [encodedEmail]);

    const handleImgChoose = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0]);
        }

    }
    /**
      * Update the value of input field on change
      * @param {*} e 
      */
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState({ ...state, [name]: value });
        // console.log(state)
    };

    /**
     * this method updates existing user to the system
     * @param {*} e 
     */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        let imageUrl = state.imageUrl;

        if (image) {
            //save profile image in storage
            const storageRef = storeRef(storage, '/tims/profile_images/' + encodedEmail);
            const uploadTask = uploadBytesResumable(storageRef, image);
            uploadTask.on('state_changed',
                (snapshot) => {
                    //progress function
                    const progress = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                    setProgress(progress);
                    console.log('Upload is ' + progress.toFixed(2) + '% done');
                },
                (error) => {
                    toast.error("Error while uploading image!");
                    setLoading(false);
                    console.error(error);
                },
                async () => {
                    //get download url from firebase storage and save it into database
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    console.log("File available at ", downloadURL);
                    setUrl(downloadURL);

                    await update(ref(db, `Users/${encodedEmail}`), {
                        // email: state.email,
                        name: state.name ? state.name : "",
                        address: state.address ? state.address : "",
                        phone: state.phone ? state.phone : "",
                        employment_type: state.employment_type ? state.employment_type : "",
                        role: state.role ? state.role : "",
                        dob: state.dob ? state.dob : "",
                        gender: state.gender ? state.gender : "",
                        imageUrl: downloadURL ? downloadURL : "",
                        updated_at: new Date().toLocaleString(),

                    })
                        .then(() => {
                            ActivityLog('My profile', state.email + '  updated');
                            toast.success("Profile updated successfully.");
                            console.log("Profile updated.");

                        })
                        .catch((error) => {

                            toast.error('Error updating user:', error);
                            console.error('Error updating user:', error);
                        });
                    setTimeout(() => navigate('/my-profile'), 1000);
                }
            );
        }
        else {
            await update(ref(db, `Users/${encodedEmail}`), {
                email: state.email,
                name: state.name ? state.name : "",
                address: state.address ? state.address : "",
                phone: state.phone ? state.phone : "",
                employment_type: state.employment_type ? state.employment_type : "",
                role: state.role ? state.role : "",
                dob: state.dob ? state.dob : "",
                updated_at: new Date().toLocaleString(),

                // imageUrl: url ? url : ""
            })
                .then(() => {
                    ActivityLog('My profile', state.email + '  updated');
                    toast.success("Profile updated successfully.");
                    console.log("Profile updated.");

                })
                .catch((error) => {
                    toast.error('Error updating user:', error);
                    console.error('Error updating user:', error);
                });
            setTimeout(() => navigate('/my-profile'), 1000);
        }


    };
    return (
        <div className='new'>
            <Sidebar />
            <div className="newContainer">

                <div className="top">
                    <h1>Update Profile</h1>
                </div>
                <div className="bottom">
                    <div className="left">
                        <div className="product-wrapper">
                            {image ? (
                                <img
                                    src={URL.createObjectURL(image)}
                                    alt="Profile"
                                    className="product-image"
                                />
                            ) : state?.imageUrl ? (
                                <img src={state.imageUrl}
                                    alt="Profile"
                                    className="product-image"
                                />
                            ) :
                                (
                                    <BsFillPersonFill className="product-icon" />
                                )}

                            <input
                                type='file'
                                id='file'
                                onChange={handleImgChoose}
                                className='product-input'
                            />
                        </div>
                    </div>

                    <div className="right">
                        <form onSubmit={handleSubmit}>
                            {/* {url && <img src={url} alt="Uploaded Profile" />} */}

                            {/* <div className="formInput">
                                {progress ?
                                    <progress value={progress} max="100" />
                                    : <br />
                                }<br />
                                <label htmlFor="file">
                                    Image:<DriveFolderUploadOutlined className='icon' />
                                </label>
                                <input
                                    type='file'
                                    id='file'
                                    onChange={handleImgChoose}
                                    style={{ display: 'none' }}
                                />
                            </div> */}
                            {/* {inputs.map((input) => (
                        <div className="formInput" key={input.id}>
                            <label type={input.type} placeholder='input.placeholder' />
                        </div>
                    ))} */}
                            <div className="formInput" >
                                <label>Email</label>
                                <input type='email'
                                    required
                                    disabled
                                    name='email'
                                    value={state.email}
                                    placeholder='Email'
                                    onChange={handleInputChange} />
                            </div>
                            <div className="formInput" >
                                <label>Name</label>
                                <input type='text'
                                    placeholder='Name '
                                    name='name'
                                    value={state.name}
                                    onChange={handleInputChange} />
                            </div>
                            <div className="formInput" >
                                <label> Address</label>
                                <input type='text'
                                    placeholder=' Address'
                                    name='address'
                                    value={state.address}
                                    onChange={handleInputChange} />
                            </div>
                            <div className="formInput" >
                                <label>Phone</label>
                                <input type='text'
                                    placeholder='Phone'
                                    name='phone'
                                    value={state.phone}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="formInput" >
                                <label>Employment Type</label>
                                <input type='text'
                                    placeholder='Employment Type'
                                    name='employment_type'
                                    value={state.employment_type}
                                    onChange={handleInputChange} />
                            </div>
                            <div className="formInput" >
                                <label>Role</label>
                                <input type='text'
                                    placeholder='Role'
                                    name='role'
                                    value={state.role}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="formInput" >
                                <label>Date of Birth</label>
                                <input type='date'
                                    placeholder='Date of Birth'
                                    name='dob'
                                    value={state.dob}
                                    onChange={handleInputChange} />
                            </div>
                            {/* 
                            <div className="formInput" >
                        <label>Gender</label>
                        <input type='text' placeholder='Gender' />
                    </div> */
                            }
                            <button type="submit" disabled={loading}>Update</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateProfile;